import React, { useCallback } from "react";
import GenericBox from "components/ui/Box";
import { House } from "lucide-react";
import { Sizes } from "components/ui/Loader";
import { usePanel } from "hooks/usePanel";
import { NsKey } from "enums/NsKey";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "app/hooks";
import { RealEstateForm } from "features/subscription-process/home-insurance/components/real-estate/RealEstateForm";
import { useSubscriptionProcessState, useRgiRiskData, useUpiRiskData } from "features/subscription-process/contexts/selectors/selectors";
import { useSubscriptionProcessActions } from "features/subscription-process/contexts/SubscriptionProcessContext";
import { SubscriptionProcessContext, useSubscriptionProcess } from "features/subscription-process/contexts/SubscriptionProcessContext";
import { refetchGlobalContracts } from "features/subscription-process/pricing-process/slices/pricing/thunks/refetchGlobalContractsThunk";
import { capitalizeFirstLetter } from "helpers/capitalizeFirstLetter";
import { BranchCode } from "api/risk";

export const InsuredPropertyCard: React.FC = () => {
  const { t } = useTranslation(NsKey.RealEstate);
  const { openPanel } = usePanel()
  const contextValue = useSubscriptionProcess()
  const dispatch = useAppDispatch()
  const { refreshSubscriptionProcess } = useSubscriptionProcessActions()

  const { branchCode, riskId } = useSubscriptionProcessState()
  const upiRiskData = useUpiRiskData()
  const rgiRiskData = useRgiRiskData()
  const realEstate = branchCode === BranchCode.RGI ? rgiRiskData?.realEstate : upiRiskData?.realEstate

  // Après modification du bien : on rafraîchit le process (carte « Le bien ») ET on relance
  // la recherche custom-global pour mettre à jour prix + éligibilité des cartouches.
  const onRealEstateSaved = useCallback(() => {
    refreshSubscriptionProcess()
    dispatch(refetchGlobalContracts())
  }, [refreshSubscriptionProcess, dispatch])

  const onSelectCard = useCallback(() => {
    if (realEstate && branchCode)
      openPanel({
        title: t("REAL_ESTATE.LABELS.EDIT_REAL_ESTATE"),
        size: Sizes["2xl"],
      },
        <SubscriptionProcessContext.Provider value={contextValue}>
          <RealEstateForm
            realEstateId={realEstate.id}
            branchCode={branchCode}
            riskId={riskId}
            refreshRealEstates={onRealEstateSaved}
          />
        </SubscriptionProcessContext.Provider>
      )
  }, [realEstate, openPanel, t, contextValue, branchCode, riskId, onRealEstateSaved])

  return (
    <GenericBox
      onSelect={onSelectCard}
      icon={House}
      title="Le bien"
    >
      <div className="flex flex-col gap-1 text-sm">
        <p className="font-medium">{`${realEstate && capitalizeFirstLetter(realEstate.name)}`}</p>
        <p className="text-gray-500">
          {realEstate?.address.line1}
        </p>
      </div>
    </GenericBox>
  );
}
